import {Platform, StyleSheet, ViewStyle} from 'react-native';
import {ColumnSize} from '@lookiero/quiz';
import {Theme} from '@lookiero/aurora';
import {iOSInAppBrowserVideoAd} from '@helpers';

const HEADER_HEIGHT = 48;

const stylesForContentContainerSize: Record<ColumnSize, ViewStyle> = {
  ['1/4']: {
    maxWidth: `${100 * (1 / 4)}%`,
  },
  ['1/3']: {
    maxWidth: `${100 * (1 / 3)}%`,
    left: `${100 * (1 / 3)}%`,
  },
  ['1/2']: {
    maxWidth: `${100 * (1 / 2)}%`,
    left: `${100 * (1 / 4)}%`,
  },
  ['2/3']: {
    maxWidth: `${100 * (2 / 3)}%`,
    left: `${100 * (1 / 6)}%`,
  },
  ['1']: {
    maxWidth: '100%',
  },
};

const style = (bottomInset = 0) => {
  const {colorBgBase, borderRadius5, colorBgSurface, space8} = Theme.get();

  return StyleSheet.create({
    card: {
      backgroundColor: colorBgBase,
      borderTopLeftRadius: borderRadius5,
      borderTopRightRadius: borderRadius5,
      height: space8,
    },
    cardContainer: {
      backgroundColor: colorBgSurface,
      height: space8,
    },
    children: {
      flexGrow: 1,
      zIndex: 20,
    },
    content: {
      paddingTop: space8,
    },
    contentContainer: {
      backgroundColor: colorBgBase,
      paddingBottom: space8 + Platform.select({android: bottomInset, default: 0}),
    },
    contentContainerLarge: {
      borderBottomLeftRadius: borderRadius5,
      borderBottomRightRadius: borderRadius5,
      marginBottom: space8,
    },
    contentContainerSmall: {
      flexGrow: 1,
    },
    header: {
      zIndex: 30,
      ...Platform.select({
        web: !iOSInAppBrowserVideoAd
          ? {
              position: 'sticky',
              top: 0,
            }
          : {},
      }),
    } as ViewStyle,
    row: {
      flex: 1,
      flexBasis: 'auto',
    },
    container: {
      backgroundColor: colorBgSurface,
    },
    stepper: {
      backgroundColor: colorBgSurface,
    },
    sticky: {
      zIndex: 10,
      ...Platform.select({
        web: {
          position: 'sticky',
        },
      }),
    } as ViewStyle,
    stickyFooter: {
      ...Platform.select({
        web: {
          bottom: 0,
          left: 0,
          position: 'fixed',
          right: 0,
          zIndex: 30,
        },
      }),
    } as ViewStyle,
    ...stylesForContentContainerSize,
  });
};

export {style, HEADER_HEIGHT};
